/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Simple_Home_Banner_DescInputs */

const en_simple_home_banner_desc = /** @type {(inputs: Simple_Home_Banner_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell your idea; Bystep writes a short plan and builds it step by step until there is a link you can open on your phone.`)
};

const id_simple_home_banner_desc = /** @type {(inputs: Simple_Home_Banner_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ceritakan ide, Bystep menyusun rencana ringkas dan membangunnya langkah demi langkah, sampai ada tautan yang bisa dibuka di HP.`)
};

/**
* | output |
* | --- |
* | "Tell your idea; Bystep writes a short plan and builds it step by step until there is a link you can open on your phone." |
*
* @param {Simple_Home_Banner_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const simple_home_banner_desc = /** @type {((inputs?: Simple_Home_Banner_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Simple_Home_Banner_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_simple_home_banner_desc(inputs)
	return en_simple_home_banner_desc(inputs)
});